<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_shelves_platformCode') || '销售渠道'"
            prop="platformCode"
          >
            <dict-select
              :value="platformTypeItem"
              :placeholder="$l('form_shelves_placeholder_platformCode') || '请选择销售渠道'"
              url="/ecom/evg/sku/platform/select"
              :options="{ label: 'label', value: 'this' }"
              filterable
              clearable
              @change="platformTypeChange"
              size="small"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_shelves_region') || '市场'">
            <el-input
              v-model="formData.regionName"
              :placeholder="$l('form_shelves_placeholder_region') || '请选择市场'"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_shelves_salesCurrencyUnit') || '货币单位'"
            prop="salesCurrencyUnit"
          >
            <dict-select
              v-model="formData.salesCurrencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="$l('placeholder_shelves_select_salesCurrencyUnit') || '请选择货币单位'"
              filterable
              clearable
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_shelves_ecomWarehouseCode') || '发货仓库'"
            prop="ecomWarehouseCode"
          >
            <dict-select
              v-model="formData.ecomWarehouseCode"
              url="/ecom/warehouse/warehouse/select/all"
              :placeholder="
                $l('placeholder_shelves_select_ecomWarehouseCode') || '请选择发货仓库'
              "
              filterable
              clearable
              size="small"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-1">
        <SkuTable :tableData="skuTableData" ref="skuTable" @delRow="delRow">
          <template v-slot:header>
            <div class="d-flex mt-2">
              <div class="side-frame-success">
                <span style="font-size: 14px; color: #606266">
                  {{ $l('table_label_put_shelves_sku') || '上架SKU' }}
                </span>
                <el-divider direction="vertical"></el-divider>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="chooseEvgSkuVisible = true"
                >
                  {{ $l('btn_put_shelves_sku') || '选择上架SKU' }}
                </el-button>

                <el-button
                  size="mini"
                  type="success"
                  plain
                  @click="chooseEvgCombineSkuVisible = true"
                >
                  {{ $l('btn_put_shelves_sku_combine') || '选择组合SKU' }}
                </el-button>
              </div>
            </div>
          </template>
        </SkuTable>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="putShelves()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <ChooseEvgSku
      :visible.sync="chooseEvgSkuVisible"
      :evgSkuStatus="['Y']"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseEvgSkuConfirm"
    />

    <ChooseEvgCombineSku
      :visible.sync="chooseEvgCombineSkuVisible"
      @confirm="chooseEvgCombineSkuConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from './sku-table'
import ChooseEvgSku from '@/views/ecom/components/choose-evg-sku'
import ChooseEvgCombineSku from '../choose-evg-combine-sku'
import { getLang } from '@/libs/util.lang'
export default {
  mixins: [EditLoading],
  components: { SkuTable, ChooseEvgSku, ChooseEvgCombineSku },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      chooseEvgSkuVisible: false,
      chooseEvgCombineSkuVisible: false,
      skuTableData: [],
      rules: {
        platformCode: [
          {
            required: true,
            message: this.$l('rules_shelves_platform') || '请选择销售渠道',
            trigger: 'change',
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            message: this.$l('rules_shelves_salesCurrencyUnit') || '请选择货币单位',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    platformTypeItem() {
      const {
        regionCode,
        regionName,
        platformCode: value,
        platformName: label,
      } = this.formData
      return { regionCode, regionName, value, label }
    },
  },
  methods: {
    platformTypeChange(e) {
      const {
        regionCode,
        regionName,
        value: platformCode,
        label: platformName,
      } = e
      this.formData = {
        ...this.formData,
        regionCode,
        regionName,
        platformCode,
        platformName,
      }
    },
    async chooseEvgSkuConfirm(data) {
      if (!data || !data.length) return
      // 判断是否已经选中的数据
      const tableData = this.skuTableData
      if (tableData?.length) {
        const findIndex = data.findIndex((item) => {
          return (
            tableData.findIndex((row) => item.evgSkuCode == row.evgSkuCode) >= 0
          )
        })
        if (findIndex >= 0) {
          this.$message(this.$l('tips_choose_evg_confirm') || '存在重复上架的SKU，已自动过滤！')
        }

        data = data.filter((item) => {
          return (
            tableData.findIndex((row) => item.evgSkuCode == row.evgSkuCode) < 0
          )
        })
      }
      if (!data || !data.length) return
      const language = getLang()
      data = data.map((item) => {
        const {
          evgSkuNo,
          goodsNameEn,
          goodsName,
          brandCode,
          brandName,
          eanCode,
        } = item
        return {
          ...item,
          uid: new Date().getTime(),
          evgSkuNo,
          channelItemNo: '',
          channelSkuNo: '',
          channelEanNo: eanCode,
          salesPrice: 0,
          actualPrice: 0,
          retailPrice: 0,
          salesCurrencyUnit: 'USD',
          salesCurrencyUnitText: language == 'en' ? 'USD' : '美元',
          operateCode: '',
          brandCode,
          brandCodeText: brandName,
          salesGoodsName: goodsNameEn || goodsName,
          salesTitle: goodsNameEn || goodsName,
          ecomWarehouseCode: '',
          whSkuNo: '',
          eachGtinNo: '',
          innerPackGtinNo: '',
          caseGtinNo: '',
          sellableEachQty: 0,
          sellableEachUnit: '',
          isCombine: 'N',
        }
      })
      this.skuTableData.push(...data)
    },
    chooseEvgCombineSkuConfirm(data) {
      if (!data?.length) return

      // 判断是否已经选中的数据
      const tableData = this.skuTableData

      if (tableData?.length) {
        const findIndex = data.findIndex((item) => {
          return (
            tableData.findIndex(
              (row) => item.evgCombineCode == row.evgSkuCode
            ) >= 0
          )
        })
        if (findIndex >= 0) {
          this.$message(
            this.$l('tips_choose_evg_confirm') ||
              '存在重复上架的SKU，已自动过滤！'
          )
        }

        data = data.filter((item) => {
          return (
            tableData.findIndex(
              (row) => item.evgCombineCode == row.evgSkuCode
            ) < 0
          )
        })
      }

      if (!data?.length) return

      const language = getLang()
      data = data.map((item) => {
        const {
          evgCombineCode: evgSkuCode,
          evgCombineNo: evgSkuNo,
          combineName: goodsName,
          combineNameEn: goodsNameEn,
          combineColor: goodsColor,
          combineColorEn: goodsColorEn,
          combineSize: goodsSize,
          combinePattern: goodsPattern,
          brandCode,
          brandName,
          eanCode,
        } = item

        return {
          ...item,
          uid: new Date().getTime(),
          evgSkuCode,
          evgSkuNo,
          goodsName,
          goodsNameEn,
          goodsColor,
          goodsColorEn,
          goodsSize,
          goodsPattern,
          channelItemNo: '',
          channelSkuNo: '',
          channelEanNo: eanCode,
          salesPrice: 0,
          actualPrice: 0,
          retailPrice: 0,
          salesCurrencyUnit: 'USD',
          salesCurrencyUnitText: language == 'en' ? 'USD' : '美元',
          operateCode: '',
          brandCode,
          brandCodeText: brandName,
          salesGoodsName: goodsNameEn || goodsName,
          salesTitle: goodsNameEn || goodsName,
          ecomWarehouseCode: '',
          whSkuNo: '',
          eachGtinNo: '',
          innerPackGtinNo: '',
          caseGtinNo: '',
          sellableEachQty: 0,
          sellableEachUnit: '',
          isCombine: 'Y',
        }
      })
      this.skuTableData.push(...data)
    },
    delRow(row) {
      const findIndex = this.skuTableData.findIndex(
        (item) => item.evgSkuCode == row.evgSkuCode
      )
      if (findIndex > -1) {
        this.skuTableData.splice(findIndex, 1)
      }
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const skuResult = await this.$refs.skuTable.validate()
      return formResult && skuResult
    },
    async putShelves() {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const listSku = this.$refs.skuTable.getTableData()
      const params = { ...this.formData, listSku }
      this.loadingOpen()
      const res = await this.$api
        .ecomEvgSkuPlatformPutShelvesApi(params)
        .catch(() => null)
      this.loadingClose()

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('tips_put_shelves_failed') || '上架失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_put_shelves_success') || '上架成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
